import React, { FC, useEffect, useMemo } from 'react';
import { HttpError, HttpStatusCode } from '@core/http';

import * as Styled from './ErrorPage.styles';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { Button, Text, Title } from '@mantine/core';
import * as Sentry from '@sentry/react';

interface ErrorPageProps {
  error?: HttpError;
}

const ErrorPage: FC<ErrorPageProps> = ({ error = HttpError.notFound }) => {
  const internalError = useRouteError();

  useEffect(() => {
    if (internalError) {
      console.error(internalError);

      if (isRouteErrorResponse(internalError) && internalError.status !== 404) {
        Sentry.captureException(internalError, {
          level: 'error',
        });
      } else {
        Sentry.captureException(internalError, {
          level: 'error',
        });
      }
    }
  }, [internalError]);

  const title = useMemo(() => {
    const getTitleFromStatus = (status: number) =>
      status === HttpStatusCode.NOT_FOUND
        ? 'La page que vous cherchez est introuvable'
        : `Une erreur ${status} est survenue`;

    if (internalError) {
      if (isRouteErrorResponse(internalError)) {
        return getTitleFromStatus(internalError.status);
      }

      return 'Erreur technique interne';
    }

    return getTitleFromStatus(error.status);
  }, [error.status, internalError]);

  return (
    <Styled.ErrorPageContainer>
      <Title>{title}</Title>

      <Text p="30px 0">Nous vous invitons à revenir à l'accueil</Text>

      <Button component={Link} to="/">
        Revenir à l'accueil
      </Button>
    </Styled.ErrorPageContainer>
  );
};

export default ErrorPage;
